export const initialListeBiancheData = {
  data: [],
  lastUpdated: "",
  loading: false,
};

export const initialCreateListeBiancheData = {
  data: {
    originAreaList: [],
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    currentItemList: [],
  },
  loading: false,
};

export const initialSelectedListeBianche = {
  data: {
    whitelistId: "",
    nome: "",
    whiteListObjectList: [],
    defaultTipoDestinazione: "",
    defaultDestinazioneId: "",
    defaultRegoleDiApplicazioneId: "",
  },
  loading: false,
};
